// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate';
import VueMoment from 'vue-moment'
import Toasted from 'vue-toasted';
import en from 'vee-validate/dist/locale/en';
import es from 'vee-validate/dist/locale/es';



import FlagIcon from 'vue-flag-icon'


import 'vue2-dropzone/dist/vue2Dropzone.min.css'


// Components
import './components'

// Plugins
import './plugins'

// Sync router with store

import { sync } from 'vuex-router-sync'

// Application imports
import App from './App' 
import i18n from '@/i18n'
import store from '@/store'
import router from '@/router'
import './filter'

// Sync store with router
sync(store, router)

Vue.use(VeeValidate ,{
  i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  dictionary: {
   en,es
  }
});
Vue.use(FlagIcon);
Vue.use(VueMoment);
Vue.use(Toasted);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
